const FILE_STATUS_CONST = Object.freeze({
  FILE_STATUS: {
    SCHEDULED: 1,
    STARTED: 2,
    AWAITED: 3,
    COMPLETED: 4,
    FAILED: 5,
    CANCELED: 6,
    ALERTED: 7,
  },
} as const);

export type FileStatusValue =
  (typeof FILE_STATUS_CONST)['FILE_STATUS'][keyof (typeof FILE_STATUS_CONST)['FILE_STATUS']];

export default FILE_STATUS_CONST;
